import React from "react";
import useUser from "../../../../hooks/super/useUser";
import { ConfirmModal } from "../../../../components/pages/_new/super/design";

function EnableUserModal({ open, handleClose, uid, userName }) {
  const { enableUser } = useUser();
  const [busy, setBusy] = React.useState(false);

  const list = Array.isArray(userName) ? userName : [];
  const plural = list.length > 1 ? "s" : "";

  const onConfirm = async () => {
    if (busy) return;
    setBusy(true);
    try {
      await enableUser(uid);
      handleClose();
    } finally {
      setBusy(false);
    }
  };

  return (
    <ConfirmModal
      open={open}
      onClose={handleClose}
      onConfirm={onConfirm}
      variant="success"
      title={`Enable user${plural}?`}
      body={`The selected user${plural} will be allowed to sign in again.`}
      items={list.map((u) => ({ id: u.id, title: u.email }))}
      submitLabel="Enable"
      loading={busy}
    />
  );
}

export default EnableUserModal;
